export default __webpack_public_path__ + "static/media/croptop-large-front-toobig.62390263.jpg";